import sc from 'styled-components';
import { WHITE, DRAWER_MARGIN_HEIGHT, DRAWER_MARGIN_WIDTH } from './styleConstants';

import React from 'react';
const Flyout = sc.section`
margin: 0;
padding: ${DRAWER_MARGIN_HEIGHT} ${DRAWER_MARGIN_WIDTH};
height: 100%;
width: 100%;
background-color: ${WHITE}
display: flex;
flex-direction: column;
`;

const Top = sc.div`
width: 100%;
flex: none;
`;

const Bottom = Top;
const Middle = sc.div`
width: 100%;
overflow-y: auto;
overflow-x: hidden;
margin: ${DRAWER_MARGIN_HEIGHT} 0;
flex: 1`;

export default ({ children }) => (<Flyout data-react="flyout">{children}</Flyout>);

export { Flyout, Top, Middle, Bottom };
